//original javascript

function resetPullDown(dropdownId) {
    var dropdown = document.getElementById(dropdownId);

    if (dropdown) {
        dropdown.selectedIndex = 0; /* ドロップダウンを初期値0に戻す */
    } else {
        console.error("IDが '" + dropdownId + "' のドロップダウンが見つかりませんでした。");
    }
}
// リセットボタン1がクリックされたときの処理
document.getElementById("resetButton1").addEventListener("click", function () {
    resetPullDown("time-picker-sdd-form"); // 配送希望時間のドロップダウン
});


//送信後サンクスページへ遷移
if (location.href.match("contact_posted=true") != null) {
  window.location.href = '/pages/thanks-page-specify-dd/';
}


//出し分け
// ページがロードされたときに実行される処理
window.addEventListener('load', function() {
  hideElementsOnLoad();
});
// 初期非表示の関数
function hideElementsOnLoad() {
  // CSSで既にdisplay: noneが指定されているため、この関数は不要です。
}
function entryChange2() {
  var selectBox = document.getElementById('deliveryMethodDropdown');
  var selectedValue = selectBox.options[selectBox.selectedIndex].value;
  if (selectedValue === '指定無し' || selectedValue === 'メール便') {
    document.getElementById('kanseirennraku-haisousizi-1').style.display = 'none';
    document.getElementById('kanseirennraku-haisousizi-2').style.display = 'none';
  } else {
    document.getElementById('kanseirennraku-haisousizi-1').style.display = 'block'; // CSSでdisplay: noneからdisplay: blockに変更
    document.getElementById('kanseirennraku-haisousizi-2').style.display = 'block'; // CSSでdisplay: noneからdisplay: blockに変更
  }
}

